import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/style.css";
import "../assets/services.css";
import LatestNews from "./LatestNews";
import ContactSection from "./ContactSection";
import WhatWeDo from "./WhatWeDo";

interface ServiceItem {
  id: number;
  title: string;
  icon: string;
  link: string;
  description: string;
  sort_order: number;
  status: "active" | "inactive";
  createdAt: string;
  updatedAt: string;
}

interface FinancialItem {
  title: string;
  description: string;
  bgClass: string;
  reverse: boolean;
}

const API_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";

const Services: React.FC = () => {
  const [services, setServices] = useState<ServiceItem[]>([]);
  const [loadingServices, setLoadingServices] = useState(true);

  const financialData: FinancialItem[] = [
    {
      title: "Excellent Strategies For",
      description:
        "Businesses begin with understanding goals, identifying challenges, and applying the right digital solutions. At LyraZone, we create smart, practical, and result-oriented strategies that improve efficiency, strengthen customer engagement, and support long-term growth. From software development to digital transformation, our approach combines innovation, reliability, and industry insight to help organizations succeed in a fast-changing and competitive business environment.",
      bgClass: "financial-p3-bg",
      reverse: false,
    },
    {
      title: "Transfer Tech Services",
      description:
        "empowers businesses and students through practical technology solutions, skill development, and real-world industry exposure. We support digital transformation by sharing technical knowledge, implementing modern systems, and guiding organizations toward smarter operations. We also cover student internships, providing valuable hands-on experience, professional mentorship, and workplace readiness so students can build confidence, strengthen technical skills, and prepare for successful future careers in the technology industry.",
      bgClass: "financial-p2-bg",
      reverse: true,
    },
  ];

  const fetchServices = async () => {
    try {
      setLoadingServices(true);

      const response = await axios.get(`${API_URL}/admin/services/public`);

      setServices(response.data?.data || []);
    } catch (error) {
      console.error("fetchServices error:", error);
      setServices([]);
    } finally {
      setLoadingServices(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <>
      {/* ====================================================
                       HOME-P
====================================================== */}

      <div id="home-p" className="home-p pages-head3 text-center">
        <div className="container">
          {/* <h1 className="wow fadeInUp" data-wow-delay="0.1s">
            Lyra Zone is fully equipped with ICT tools
          </h1>
          <p>Our Services</p> */}
        </div>
      </div>

      {/* ====================================================
                      BUSINESS-GROWTH-P1
        ====================================================== */}

      <section id="business-growth-p1" className="business-growth-p1 bg-gray">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">We committed to helping</h1>
              <div className="heading-border"></div>
              <p className="wow fadeInUp" data-wow-delay="0.4s">
                We are a leading zone of Information & Communication Technology
                (ICT). We have in-house and collaborated services to facilitate
                our clients like One-Window-Operation. We have developed
                Accounting and Point of Sales Solutions with real-time
                connectivity and reporting. We have experts to develop
                responsive and eCommerce websites.
              </p>
            </div>
          </div>

          <div
            className="row wow animated fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            {loadingServices ? (
              <div className="col-md-12 text-center">
                <p>Loading services...</p>
              </div>
            ) : services.length > 0 ? (
              services.map((service, index) => (
                <div
                  key={service.id}
                  className={`col-md-3 col-sm-6 service-padding ${
                    index === services.length - 1 ? "right-bord" : ""
                  }`}
                >
                  <div
                    className="service-item"
                    onClick={() => {
                      if (service.link) {
                        window.location.href = service.link;
                      }
                    }}
                    style={{ cursor: service.link ? "pointer" : "default" }}
                  >
                    <div className="service-item-icon">
                      <i className={`fa ${service.icon} fa-3x`}></i>
                    </div>
                    <div className="service-item-title">
                      <h3>{service.title}</h3>
                    </div>
                    <div className="service-item-desc">
                      <p>{service.description}</p>
                      <div className="content-title-underline-light"></div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-12 text-center">
                <p>No services available.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ====================================================
                      FINANCIAL-P1
====================================================== */}

      {financialData.map((item, index) => (
        <section
          key={index}
          id="financial-p1"
          className={`bg-parallax ${item.bgClass}`}
        >
          <div className="overlay-financial-p1"></div>
          <div className="container-fluid">
            <div className="row">
              {item.reverse ? (
                <>
                  <div className="col-md-6 financial-p1-emp-img"></div>
                  <div className="col-md-6 financial-p1-pos financial-p1-emp-desc-d">
                    <FinancialContent
                      title={item.title}
                      description={item.description}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-md-6 financial-p1-pos">
                    <FinancialContent
                      title={item.title}
                      description={item.description}
                    />
                  </div>
                  <div className="col-md-6 financial-p1-emp-img"></div>
                </>
              )}
            </div>
          </div>
        </section>
      ))}

      <WhatWeDo />

      {/* ====================================================
                        FINANCIAL-P6
    ====================================================== */}

      <section id="financial-p6" className="financial-p6">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="financial-p6-img">
                <img
                  src="src/assets/img/image-3.jpg"
                  className="img-fluid wow fadeInUp"
                  data-wow-delay="0.1s"
                  alt="LyraZone"
                />
                <img src="" alt="" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="financial-p6-cont">
                <h2 className="wow fadeInUp">Creative Idea LyraZone</h2>
                <div className="heading-border-light"></div>
                <p>
                  Reflects our passion for transforming imagination into
                  practical digital solutions. We believe every great business
                  begins with a powerful idea, and our role is to shape that
                  idea into meaningful results. Through innovation, technology,
                  and strategic thinking, LyraZone delivers creative concepts
                  that enhance business growth, improve user experience, and
                  open new opportunities for success in today’s fast-moving
                  digital world.
                </p>
                <button className="btn btn-general btn-white" role="button">
                  Contact
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactSection />
      <LatestNews />
    </>
  );
};

const FinancialContent: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => (
  <div className="financial-p1-cont">
    <a href="#">
      <b>LyraZone Solutions</b>
    </a>
    <h3>{title}</h3>
    <p>{description}</p>
    <button className="btn btn-general btn-white" role="button">
      Contact Us
    </button>
  </div>
);

export default Services;
